<dx-date-box
  type="date"
  displayFormat="dd/MM/yyyy"
  #dateInput
  [attr.name]="nameString"
  [attr.tabindex]="tabIndexValue"
  placeholder="Date"
  class="focusable"
  [(value)]="time"
  [(ngModel)]="time"
  openOnFieldClick="true"
  (ngModelChange)="changeModelState()"
  (blur)="onblurEvent()"
  [required]="requiredValue"
  [readonly]="disabledValue"
  [min]="minValue"
  (onFocusOut)="onblurEvent()"
  (onFocusIn)="onFocusIn()"
  (onInitialized)="onInitialized.emit($event)"
  (onClosed)="pickerClosed()"
  [disabled]="disabledValue">
</dx-date-box>
